import { ForwardToStationSelectionResult } from './../../../../../forward-to-station/model/forward-to-station.model';
import { ForwardToStationService } from './../../../../../forward-to-station/service/forward-to-station.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { ProcessingStatus } from 'src/tmc-yard/client/model/processing-status';
import { ProcessingStatusModel } from 'src/tmc-yard/client/model/processing-status-model';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { TranslationService } from '@sdbn/common';
import { AssignTransportToStation, ForwardToProcess, SendTransportToStation, SetProcessingStatus, TransportStationAssignment } from '../../../../model/sac-client.model';
import { ClientStatusService, DialogService, ResponseMessage } from '@sdbn/appclient';
import { CancelTransportDialogComponent, CancelTransportDialogData } from '../../../cancel-transport-dialog/cancel-transport-dialog.component';
import { SacClientContext } from '../../../../model/sac-client.context';
import { StationSelectionService } from 'src/tmc-yard/components/station-selection/service/station-selection.service';
import { StationSelectionIdentity } from 'src/tmc-yard/components/station-selection/model/StationSelectionIdentity';
import { SacClientService } from '../../../../service/sac-client.service';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransportOptionSelectionComponent, TransportOptionSelectionDialogData } from '../../../transport-option-selection/transport-option-selection.component';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { ResponseStatus } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';
import { RoutingOption, RoutingOptionType } from 'src/tmc-yard/client/model/station-usage.model';
import { Station } from 'src/tmc-yard/client/model/station';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { map } from 'rxjs/operators';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { Transport, TransportScope } from 'src/tmc-yard/common/model/transport.model';
import { StationType } from 'src/tmc-yard/client/model/station-type.enum';

@Component({
  selector: 'app-station-transport-action-bar',
  templateUrl: './station-transport-action-bar.component.html',
  styleUrls: ['./station-transport-action-bar.component.scss']
})
export class StationTransortActionBarComponent implements OnInit, OnDestroy {

  isLoading = false;
  responseMessages: ResponseMessage[];

  // Felder für Template
  backwardStatusButtonDictionaryKey: string;
  forwardStatusButtonDictionaryKey: string;
  isBackwardStatusButtonVisible: boolean;
  isForwardStatusButtonVisible: boolean;

  // Alle verfügbaren Modelle
  processingStatusModels: ProcessingStatusModel[];

  // Der Aktuelle Wert des Statusmodells
  processingStatusModelValue: string;

  // Das zu verwendende Statusmodell
  processingStatusModel: ProcessingStatusModel;

  processingStatusIndex = -1;
  nextProcessingStatus: ProcessingStatus;
  previousProcessingStatus: ProcessingStatus;
  currentProcessingStatus: ProcessingStatus;

  yardConfigSubscription: Subscription;

  sacClientContext: SacClientContext;
  transport: Transport;

  clientParameters = TMCClientParameters;

  @Input() station: Station;
  @Input() stationSet: StationSet;

  get isConfirmButtonVisible(): boolean {

    // wenn es sich nicht um eine Wartezone handelt
    if (this.station?.stationType === StationType.WAITING_AREA) {
      return false;
    }

    // wenn es kein Statusmodell für die aktuelle Position gibt
    if (this.processingStatusModel == null) {
      return true;
    }

    // Wenn keine Statusmodelle konfiguriert sind
    if (this.processingStatusModels == null || this.processingStatusModels.length === 0) {
      return true;
    }

    // oder der letzte Status erreicht ist
    if (this.processingStatusModel.status[this.processingStatusModel.status.length - 1]?.key
      === this.station?.stationUsage.processingStatusModelValue) {
      return true;
    }
    return false;
  }

  get isConfirmOptionsDisabled() {
    if (!this.station.stationUsage.completeAssigmentAllowed) {
      return true;
    }
    if (this.isLoading) {
      return true;
    }
    return !this.station?.stationUsage.selectedOption;
  }

  get changeProcessingStatusAllowed() {
    return !this.isLoading && this.station?.stationUsage.changeProcessingStatusAllowed;
  }

  get changeProcessingStatusNextAllowed() {
    return !this.isLoading && this.station?.stationUsage.changeProcessingStatusNextAllowed;
  }

  get cancelAllowed() {
    return !this.isLoading && this.station?.stationUsage.cancelAllowed
      && (this.transport?.masterdata.transportScope === TransportScope.TRAIN || this.transport?.masterdata.transportScope === TransportScope.SEMI_TRAILER_TRUCK);
  }



  @Input('station') set setStationUsage(station: Station) {
    this.station = station;
    this.updateProcessingStatusViewModel();
  }

  // Input mandatory for change detection on stationUsage.processingStatusModelValue!!
  @Input() set setProcessingStatusModelValue(processingStatusModelValue: string) {
    this.processingStatusModelValue = processingStatusModelValue;
    this.updateProcessingStatusViewModel();
  }

  // Input mandatory for change detection on stationUsage.processingStatusModel!!
  @Input() set setProcessingStatusModel(processingStatusModel: string) {
    this.updateProcessingStatusViewModel();
  }


  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
  }

  @Input('transport') set setTransport(transport: Transport) {
    this.transport = transport;
  }



  constructor(
    private tmcContextService: TmcContextService,
    private stationSelectionService: StationSelectionService,
    private forwardToStationService: ForwardToStationService,
    private sacClientService: SacClientService,
    private dialog: MatDialog,
    private cps: ConfigurationService,
    public translationService: TranslationService,
    private httpService: HttpService,
    private dialogService: DialogService,
    public clientStatusService: ClientStatusService
  ) {

    this.yardConfigSubscription = this.tmcContextService.updated.subscribe(
      next => {
        if (next != null) {
          this.processingStatusModels = this.tmcContextService.getYardConfiguration().processingStatusModels;
          this.updateProcessingStatusViewModel();
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.yardConfigSubscription != null) {
      this.yardConfigSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
  }

  private updateProcessingStatusViewModel() {
    console.log('updateProcessingStatusViewModel', this.processingStatusModels, this.station?.stationUsage?.processingStatusModel);
    if (this.processingStatusModels == null) {
      return;
    }

    for (const processingStatusModel of this.processingStatusModels) {
      if (processingStatusModel.key === this.station?.stationUsage?.processingStatusModel) {
        this.processingStatusModel = processingStatusModel;
        break;
      }
    }

    if (this.processingStatusModel == null) {
      return;
    }

    if (this.processingStatusModelValue != null) {
      const current = this.processingStatusModel.status.find(s => s.key === this.processingStatusModelValue);
      this.processingStatusIndex = this.processingStatusModel.status.indexOf(current);
      this.previousProcessingStatus = this.processingStatusModel.status[this.processingStatusIndex - 1];
      this.currentProcessingStatus = this.processingStatusModel.status[this.processingStatusIndex];
      this.nextProcessingStatus = this.processingStatusModel.status[this.processingStatusIndex + 1];
    } else {
      this.processingStatusIndex = -1;
      this.previousProcessingStatus = null;
      this.currentProcessingStatus = null;
      this.nextProcessingStatus = this.processingStatusModel.status[0];
    }

    this.isBackwardStatusButtonVisible = this.processingStatusModel != null && this.currentProcessingStatus != null;
    this.isForwardStatusButtonVisible = this.processingStatusModel != null && this.nextProcessingStatus != null;
    this.backwardStatusButtonDictionaryKey = this.currentProcessingStatus?.dictionaryKeyBackward || '';
    this.forwardStatusButtonDictionaryKey = this.nextProcessingStatus?.dictionaryKeyForward || 'FEHLER!';
    console.log(this.processingStatusModel, 'isBackwardStatusButtonVisible', this.isBackwardStatusButtonVisible, 'isForwardStatusButtonVisible', this.isForwardStatusButtonVisible);
  }

  public handlePreviousProcessingStatus() {
    if (this.processingStatusIndex > 0) {
      this.setProcessingStatus(this.processingStatusModel.status[this.processingStatusIndex - 1].key);
    } else {
      this.setProcessingStatus(null);
    }
  }

  public handleNextProcessingStatus() {
    if (this.processingStatusModel.status.length - 1 > this.processingStatusIndex) {
      this.setProcessingStatus(this.processingStatusModel.status[this.processingStatusIndex + 1].key);
    }
  }

  private setProcessingStatus(processingStatusValue: string) {
    this.isLoading = true;

    const request = new SetProcessingStatus();
    request.oldProcessingStatusModelValue = this.station.stationUsage.processingStatusModelValue;
    request.processingStatusModelValue = processingStatusValue;

    const tsa = new TransportStationAssignment();
    tsa.station = { id: this.station.id };
    tsa.transport = { id: this.station.stationUsage.transports[0].id };
    request.transportStationAssignment = tsa;

    this.sacClientService.setProcessingStatus(request).subscribe(next => {
      this.tmcContextService.forceRefreshOfStationUsages();
      this.isLoading = false;
    }, error => {
      this.tmcContextService.forceRefreshOfStationUsages();
      console.error('Error updating assignment status!');
      this.isLoading = false;
    });
  }

  public cancelAction() {

    this.responseMessages = [];

    if (this.station && this.transport) {

      const assignment = new TransportStationAssignment();
      assignment.transport = { id: this.transport.id };
      assignment.station = { id: this.station.id };
      this.isLoading = true;

      forkJoin(
        this.sacClientService.getStationsForCancellation(assignment),
        this.stationSelectionService.getStationStructureDefinition(new StationSelectionIdentity())
      ).subscribe(results => {

        this.isLoading = false;
        const dialogData: CancelTransportDialogData = {
          assignment,
          stationForRepeatProcessing: results[0],
          stationForForwarding: results[1],
          carrier: this.transport.masterdata.carrier,
          driver: this.transport.masterdata.driverName,
          transportScope: this.transport.masterdata.transportScope,
          identifier: this.transport.identifyingNumberplate
        };

        this.dialog.open(CancelTransportDialogComponent, {
          data: dialogData,
          panelClass: DialogLayout.panelClass
        }).afterClosed().subscribe(() => {
          this.tmcContextService.forceRefreshOfStationUsages();
        });

      }, error => {
        console.error(error);
        this.isLoading = false;
      });
    }
  }

  getStyles(option: RoutingOption) {
    const classes: string[] = [];
    if (option.style) {
      classes.push(option.style);
    }

    // if (option.level) {
    //   classes.push('level-' + option.level);
    // }

    return classes;
  }

  public confirmOptions() {
    if (this.station?.stationUsage.selectedOption?.routingOptionType === RoutingOptionType.SELECT_STATION) {
      this.sendToSelectedStation();
    } else if (this.station?.stationUsage.selectedOption?.routingOptionType === RoutingOptionType.FORWARD_TO_PROCESS) {
      this.forwardTransportToProcess();
    } else if (this.station?.stationUsage.selectedOption?.routingOptionType === RoutingOptionType.RESTART_ROUTE) {
      this.selectTransportOptionsAndRestart();
    } else if (this.station?.stationUsage.selectedOption?.routingOptionType === RoutingOptionType.CREATE_MOVING_ORDER) {
      this.createMovingOrder();
    } else {
      this.sendToNextStationAction();
    }
  }

  private async createMovingOrder() {

    this.responseMessages = [];

    if (this.station && this.transport) {

      this.isLoading = true;

      let forward: ForwardToProcess = null;

      if (!this.transport.hasMorePositions) {
        const dialogData = new TransportOptionSelectionDialogData();
        dialogData.carrier = this.transport.masterdata.carrier;
        dialogData.driver = this.transport.masterdata.driverName;
        dialogData.transportScope = this.transport.masterdata.transportScope;
        dialogData.identifier = this.transport.identifyingNumberplate;
        const result = await this.dialogService.openMiddle(TransportOptionSelectionComponent, dialogData).afterClosed().toPromise();

        if (result == null) {
          return;
        }

        forward = result as ForwardToProcess;

      }

      this.httpService.postWithContext<ServiceResponse>(`${environment.sacClientEndpoint}/create-moving-order`,
        { transportId: this.transport.id, targetStationId: null, currentStationId: this.station.id, extendProcessByOptions: forward?.selectedOptionIds, useAsVehicle: forward?.asVehicle }).subscribe(result => {
          if (result.status === ResponseStatus.SUCCESS) {

            this.tmcContextService.forceRefreshOfStationUsages();

          }
          this.isLoading = false;
          this.responseMessages = result.responseMessages;
        }, error => {
          console.error(error);
          this.isLoading = false;
        });
    }

  }

  private sendToNextStationAction() {

    this.responseMessages = [];

    if (this.station && this.transport) {

      const action = new SendTransportToStation();
      action.routingOptionType = this.station.stationUsage.selectedOption.routingOptionType;
      action.transportStationAssignment = { station: { id: this.station.id }, transport: { id: this.transport.id } };
      action.targetStation = { id: this.station.stationUsage.selectedOption.refrence };

      this.isLoading = true;

      this.sacClientService.sendTransportToStation(action).subscribe(result => {
        if (result.status === ResponseStatus.SUCCESS) {

          this.tmcContextService.forceRefreshOfStationUsages();

          if (result.suggestedTransportId != null) {
            const dialogData: ConfirmDialogData = {
              titleKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.title',
              messageKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.message',
              messageParams: [result.suggestTransportDescription],
              confirm: () => this.assignSuggestedTransportToStation(result.suggestedTransportId)
            };

            this.dialog.open(ConfirmDialogComponent, {
              data: dialogData,
            });

          }
        }
        this.isLoading = false;
        this.responseMessages = result.responseMessages;
      }, error => {
        console.error(error);
        this.isLoading = false;
      });
    }
  }

  private assignSuggestedTransportToStation(transportId: number) {
    this.isLoading = true;

    this.responseMessages = [];

    const assignment = new AssignTransportToStation();
    assignment.transportStationAssignment = { station: { id: this.station.id }, transport: { id: transportId } };
    assignment.asBackup = false;
    assignment.workingStationSet = { id: this.stationSet.id };

    this.httpService.postWithContext<ServiceResponse>(environment.sacClientEndpoint + '/assign-transport', assignment).pipe(
      map(sr => new ServiceResponse(sr)))
      .subscribe(
        response => {
          this.responseMessages = response.responseMessages;
          this.tmcContextService.forceRefreshOfStationUsages();
          this.isLoading = false;
        },
        error => {
          console.error(error);
          this.isLoading = false;
        }
      );
  }

  private sendToSelectedStation() {

    this.responseMessages = [];

    const property = this.cps.getClientParamValue(
      'ui-component.station-assignment-client.send-to-station.selection-level',
      'station-and-station-set');
    const inculdeStations = property === 'station-and-station-set';

    this.forwardToStationService.selectStationSetOrStation().subscribe(
      selectionResult => {
        console.log('forwardToStationService:', selectionResult);

        if (selectionResult == null) {
          return;
        }
        this.isLoading = true;

        const forwardToStationSelectionResult: ForwardToStationSelectionResult = selectionResult;

        const action = new SendTransportToStation();
        action.routingOptionType = this.station.stationUsage.selectedOption.routingOptionType;
        action.forwardingOptionDictionaryKey = forwardToStationSelectionResult.reasonOptionDictionaryKey;
        action.transportStationAssignment = { station: { id: this.station.id }, transport: { id: this.transport.id } };

        if (forwardToStationSelectionResult.stationId != null) {
          action.targetStation = { id: forwardToStationSelectionResult.stationId };
        } else if (forwardToStationSelectionResult.stationSetId != null) {
          action.targetStationSet = { id: forwardToStationSelectionResult.stationSetId };
        }

        this.sacClientService.sendTransportToStation(action).subscribe(result => {
          if (result.status === ResponseStatus.SUCCESS) {

            this.tmcContextService.forceRefreshOfStationUsages();

            if (result.suggestedTransportId != null) {
              const dialogData: ConfirmDialogData = {
                titleKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.title',
                messageKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.message',
                messageParams: [result.suggestTransportDescription],
                confirm: () => this.assignSuggestedTransportToStation(result.suggestedTransportId)
              };

              this.dialog.open(ConfirmDialogComponent, {
                data: dialogData,
              });

            }
          }
          this.isLoading = false;
          this.responseMessages = result.responseMessages;
        }, error => {
          console.error(error);
          this.isLoading = false;
        });
      },
      error => {
        console.error('Forward to station selection failed', error);
        this.isLoading = false;
      }
    );
  }

  private selectTransportOptionsAndRestart() {
    this.responseMessages = [];

    if (this.station && this.transport) {

      const dialogData = new TransportOptionSelectionDialogData();
      dialogData.carrier = this.transport.masterdata.carrier;
      dialogData.driver = this.transport.masterdata.driverName;
      dialogData.transportScope = this.transport.masterdata.transportScope;
      dialogData.identifier = this.transport.identifyingNumberplate;

      this.dialogService.openMiddle(TransportOptionSelectionComponent, dialogData).afterClosed().subscribe(result => {

        if (result != null) {

          const action = new SendTransportToStation();
          action.routingOptionType = this.station.stationUsage.selectedOption.routingOptionType;
          action.transportStationAssignment = {
            station: { id: this.station.id },
            transport: { id: this.transport.id }
          };
          action.transportOptionIds = result.selectedOptionIds;

          this.isLoading = true;

          this.sacClientService.sendTransportToStation(action).subscribe(result => {
            if (result.status === ResponseStatus.SUCCESS) {

              this.tmcContextService.forceRefreshOfStationUsages();

              if (result.suggestedTransportId != null) {
                const confirmDdialogData: ConfirmDialogData = {
                  titleKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.title',
                  messageKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.message',
                  messageParams: [result.suggestTransportDescription],
                  confirm: () => this.assignSuggestedTransportToStation(result.suggestedTransportId)
                };

                this.dialog.open(ConfirmDialogComponent, {
                  data: confirmDdialogData,
                });

              }
            }
            this.isLoading = false;
            this.responseMessages = result.responseMessages;
          }, error => {
            console.error(error);
            this.isLoading = false;
          });

        }

      });
    }
  }

  private forwardTransportToProcess() {
    this.responseMessages = [];

    if (this.station && this.transport) {

      const dialogData = new TransportOptionSelectionDialogData();
      dialogData.carrier = this.transport.masterdata.carrier;
      dialogData.driver = this.transport.masterdata.driverName;
      dialogData.transportScope = this.transport.masterdata.transportScope;
      dialogData.identifier = this.transport.identifyingNumberplate;

      this.dialogService.openMiddle(TransportOptionSelectionComponent, dialogData).afterClosed().subscribe(result => {

        if (result != null) {

          const action = new SendTransportToStation();
          action.routingOptionType = this.station.stationUsage.selectedOption.routingOptionType;
          action.transportStationAssignment = {
            station: { id: this.station.id },
            transport: { id: this.transport.id }
          };
          action.transportOptionIds = result.selectedOptionIds;

          this.isLoading = true;

          this.sacClientService.sendTransportToStation(action).subscribe(result => {
            if (result.status === ResponseStatus.SUCCESS) {

              this.tmcContextService.forceRefreshOfStationUsages();

              if (result.suggestedTransportId != null) {
                const confirmDdialogData: ConfirmDialogData = {
                  titleKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.title',
                  messageKey: 'tmc-yard.widgets.sac-client.station-transport-details.assign-suggested-transport-to-station.confirm-dialog.message',
                  messageParams: [result.suggestTransportDescription],
                  confirm: () => this.assignSuggestedTransportToStation(result.suggestedTransportId)
                };

                this.dialog.open(ConfirmDialogComponent, {
                  data: confirmDdialogData,
                });

              }
            }
            this.isLoading = false;
            this.responseMessages = result.responseMessages;
          }, error => {
            console.error(error);
            this.isLoading = false;
          });

        }

      });
    }
  }

  handleChange() {

  }


}
